import { render, staticRenderFns } from "./Range.vue?vue&type=template&id=b852b532"
import script from "./Range.vue?vue&type=script&lang=js"
export * from "./Range.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports